<template>

    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addProductListing/>
    </v-dialog>

</template>

<script>
    import {ProductListings} from '../../store/namespace-helper'

    import addProductListing from '../Shared/AddProductListing.vue'

    export default {
      name: 'add-new-products-listings-dialog',
      components: {
        addProductListing
      },
      data () {
        return {}
      },
      methods: {},
      computed: {
        dialog () {
          return this.$store.getters[ProductListings.getters.getDialogState]
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProductListings/AddProductListingsDialog.vue